import Link from 'next/link';
import styles from './PersonalDataLabel.module.scss';
import { PRIVACY_POLICY_URL } from '@/constants';

export function PersonalDataLabel() {
  return (
    <p className={styles.label}>
      Я согласен(на) на{' '}
      <Link href={PRIVACY_POLICY_URL} className={styles.link} target="_blank">
        обработку персональных данных
      </Link>
    </p>
  );
}
